// Първи екран след бърза регистрация (телефон + парола): питаме за име и
// фамилия. Нужни са за договорите, фактурите и за да знаят наемателите кой
// им пише — но не и за да започне човекът да ползва приложението.
import React, { useState } from 'react';
import { View } from 'react-native';
import { useNavigation } from '@react-navigation/native';
import { api } from '../api';
import { useAuth } from '../AuthContext';
import { showError } from '../toast';
import { Button, Card, Constrain, Input, Label, Muted, Screen, Title } from '../ui';
import { t } from '../i18n';

export default function CompleteNameScreen() {
  const navigation = useNavigation<any>();
  const { refreshUser } = useAuth();
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [loading, setLoading] = useState(false);

  const save = async () => {
    setLoading(true);
    try {
      await api('/me/profile', { method: 'PATCH', body: { firstName: firstName.trim(), lastName: lastName.trim() } });
      await refreshUser();
      navigation.reset({ index: 0, routes: [{ name: 'Dashboard' }] });
    } catch (e: any) {
      showError(e.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Screen>
      <Constrain>
        <Title>{t('Добре дошли в Livupp 👋')}</Title>
        <Muted>{t('Само още едно нещо — как да ви наричаме? Имената влизат в договорите и фактурите ви.')}</Muted>
        <Card style={{ marginTop: 12 }}>
          <Label>{t('Име')}</Label>
          <Input value={firstName} onChangeText={setFirstName} placeholder={t('Иван')} autoFocus />
          <Label>{t('Фамилия')}</Label>
          <Input value={lastName} onChangeText={setLastName} placeholder={t('Иванов')} />
          <View style={{ marginTop: 4 }}>
            <Button title={t('Продължи')} onPress={save} disabled={!firstName.trim() || !lastName.trim()} loading={loading} />
          </View>
        </Card>
      </Constrain>
    </Screen>
  );
}
